import * as React from 'react';

import './ValidationStatus.scss';

import { ValidationState } from '@models';

export interface IValidationStatusStateProps {
  validationStatus: ValidationState;
}

const Validating: React.FC<IValidationStatusStateProps> = ({
  validationStatus,
}) => (
  <React.Fragment>
    {validationStatus === ValidationState.inProgress && (
      <div
        className='spinner-border fcolor--success spinner-border-sm uploading-icon'
        role='status'
      >
        <span className='sr-only'></span>
      </div>
    )}
    {validationStatus === ValidationState.passed && (
      <span className='validation-icon'>
        <i className='fas fa-check fcolor--success'></i>
      </span>
    )}
    {validationStatus === ValidationState.failed && (
      <span className='validation-icon'>
        <i className='fas fa-times fcolor--error'></i>
      </span>
    )}
  </React.Fragment>
);

export default Validating;
